export default "__VITE_ASSET__eaa12fc3__"